import { ReactNode } from 'react'

export type FooterLinksProps = {
	className?: string
	children?: ReactNode
}

export const FooterLinks: React.FC<FooterLinksProps> = ({ className }) => {
	return (
		<div className={className || 'p-4 text-center text-primary-text'}>
			<div className="text-xs">
				<a
					className="hover:text-link-hover transition-all duration-300"
					href="/terms-of-service"
					target="_blank"
					rel="noopener noreferrer"
				>
					Terms
				</a>
				{` and `}
				<a
					className="hover:text-link-hover transition-all duration-300"
					href="/privacy-policy"
					target="_blank"
					rel="noopener noreferrer"
				>
					Privacy
				</a>
			</div>
			<div className="text-xs mt-2">&copy;Loyalink {new Date().getFullYear()}</div>
		</div>
	)
}
